<template>
    <div class="add-data-panel">
        <label class="item-label" :class="{ 'item-label-en': $i18n.locale != 'cn' }">
            <span class="required" v-show="isShowRequired">{{ requiredIcon }}</span>
            {{ label }}
        </label>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "AddDataPanel",
    props: ["label", "required"],
    data() {
        return {
            requiredIcon: "*",
            isShowRequired: this.required == undefined ? true : this.required
        };
    }
};
</script>

<style lang="less" scoped>
.add-data-panel {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 24px;
    margin-right: 24px;
    :global(.el-tree-node__label) {
        font-size: 12px;
    }
    .item-label {
        position: relative;
        padding-left: 10px;
        margin-right: 8px;
        margin-top: 8px;
        min-width: 125px;
        text-align: right;
    }
    .item-label-en {
        width: 130px;
    }
    .required {
        color: #fe0931;
    }
}
</style>
